module.exports = __webpack_public_path__ + "media/temp/vampire-icon-8fbc6a73.png";